import { render, staticRenderFns } from "./PosMyOrderList.vue?vue&type=template&id=31924863&scoped=true&"
import script from "./PosMyOrderList.vue?vue&type=script&lang=js&"
export * from "./PosMyOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31924863",
  null
  
)

export default component.exports